export default __webpack_public_path__ + "static/media/decada-0060-0002-min.8457c71c.jpg";